import type { DogBreederContactType } from '@gql/graphql';
import type { HeaderProfileData } from '@presentation/components';
import type { Dayjs } from 'dayjs';
import type { FormikConfig } from 'formik';

export interface BreederWriteReviewFormValues {
  globalGrade: number;
  acceptedTerms: boolean;
  description: string;
  contactDate: Dayjs | undefined;
  contactType: DogBreederContactType;

  microchip?: string;
  humanContactGrade?: number;
  hygieneGrade?: number;
  dogsWellBeingGrade?: number;
  followUpGrade?: number;
}

export interface BreederWriteReviewPageData {
  header?: HeaderProfileData;
  form: {
    initialValues: BreederWriteReviewFormValues;
    onSubmit: (values: BreederWriteReviewFormValues) => void;
    validate: FormikConfig<BreederWriteReviewFormValues>['validate'];
  };
}

export interface BreederWriteReviewPageProps extends BreederWriteReviewPageData {}
